import { useState, useCallback, useMemo, useEffect } from 'react'

export default function hookReportStoreFactory() {
  return () => {
    const [attachedToSite, setAttachedToSiteSite] = useState(true)

    const list = useCallback(async params => { }, [])

    return useMemo(() => ({
      attachedToSite,
      report: {
        list,

        useLoad: (params, attachedToSite = true) => {
          useEffect(() => {
            list(params)
          }, [params])

          useEffect(() => {
            setAttachedToSiteSite(attachedToSite)
          }, [attachedToSite])

          return useCallback(() => list(params), [params])
        },
      },

    }), [attachedToSite, list])
  }
}
